<template>
  <!--  <div class="update-dialog" v-if="true">-->
  <!--    <div class="update-dialog__content">-->
  <!--      {{ $t("newVersionFoundHint") }}-->
  <!--    </div>-->
  <!--    <div class="text-right">-->
  <!--      <v-btn text dark @click="update">-->
  <!--        {{ $t("update") }}-->
  <!--      </v-btn>-->
  <!--    </div>-->
  <!--  </div>-->
  <div>
    <v-dialog max-width="400px" v-model="prompt">
      <v-card>
        <div
          class="d-flex flex-column align-center text-container mb-4"
          style="gap: 10px; padding: 20px 0px"
        >
          <img :src="require('@/assets/img/done-icon.png')" alt="limit img" />

          <h3 style="text-align: center; width: 350px">
            {{ $t("newVersionFoundHint") }}
          </h3>
          <div class="action-container d-flex mt-5" style="gap: 10px">
            <v-btn color="primary" @click="update">
              {{ $t("updateNewVersion") }}
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "UpdateMessageBox",
  data() {
    return {
      prompt: false,
    };
  },
  methods: {
    async update() {
      this.showLoading();
      this.prompt = false;
      await this.$workbox.messageSW({ type: "SKIP_WAITING" });
    },
  },
  created() {
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.prompt = true;
      });
    }
  },
};
</script>

<style lang="scss">
.update-dialog {
  position: fixed;
  right: 50px;
  bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 12px;
  max-width: 576px;
  color: #fff;
  background-color: #01456a;
  text-align: left;
}
</style>
